<template>
  <v-row>
    <!-- Categories -->
    <v-col v-if="!$vuetify.display.mobile && categoriesShown" lg="3" xl="2">
      <product-categories
        :show-hide-button="currentRoute.name !== 'StartPage'"
        @update="selectCategory"
      />
    </v-col>
    <!-- Content -->
    <v-col cols="12" :lg="categoriesShown ? 9 : 12" :xl="categoriesShown ? 10 : 12">
      <error-component v-if="mustHandleError" :error="error" transparent-background />
      <router-view v-else />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import ProductCategories from '@/modules/categories/components/ProductCategories.vue'
import useCategories from '@/modules/categories/useCategories'
import { categoriesQueryOptions } from '@/modules/categories/useCategoriesColada'
import ErrorComponent from '@/modules/error/components/ErrorComponent.vue'
import { customErrorHandling } from '@/modules/error/helpers'
import { StorefrontProductSort } from '@/modules/product/types'
import useProductFilter from '@/modules/product/useProductFilter'
import useStartPage from '@/modules/startPage/useStartPage'
import router from '@/router'
import { StartPageType } from '@/types/index'
import { useQuery } from '@pinia/colada'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

defineOptions({ name: 'CategoryLayout' })

const currentRoute = useRoute()
if (!currentRoute.path.startsWith('/products/category')) {
  useQuery(categoriesQueryOptions())
}

const { error, mustHandleError } = customErrorHandling()

const { startPage } = storeToRefs(useStartPage())
const { showCategories } = storeToRefs(useCategories())

const categoriesShown = computed(() => {
  if (currentRoute.name === 'StartPage') {
    return startPage.value.startPageType !== StartPageType.CATEGORIES
  } else {
    return showCategories.value
  }
})

const selectCategory = (categorySearchTerm: string) => {
  if (currentRoute.params.id !== categorySearchTerm) {
    useProductFilter().resetFilter(StorefrontProductSort.POPULARITY)
    useProductFilter().category = categorySearchTerm
    router.push({
      name: 'Category',
      params: { id: categorySearchTerm }
    })
  }
}
</script>
